import React from 'react';
import { useSelector } from 'react-redux';
import Messages from './Messages';
const MessagesContainer = ({ mode, renderMode, messageRef }) => {
    const { messages, statusMessage } = useSelector((state) => state.messages);
    const propsWithRedux = { mode, renderMode, messageRef, messages, statusMessage };
    return React.createElement(Messages, Object.assign({}, propsWithRedux));
};
export default React.memo(MessagesContainer);
//# sourceMappingURL=MessagesContainer.js.map